import React from 'react';
import PropTypes from 'prop-types';

import CourseName from '../../../../CourseName/CourseName';
import { useLocation, useNavigate } from 'react-router-dom';
import ButtonIcon from '../../../../../common/ButtonIcon/ButtonIcon';
import VocabularyButton from '../../../../../common/VocabularyButton/VocabularyButton';
import Button from '../../../../../common/Buttons/Button';

import { homeworkColors } from '../../../../schedule/constants';

const ProgramsTableRow = ({ course, getAccounts }) => {

  const navigate = useNavigate();
  const location = useLocation();
  const setHomeworkPage = () => {
    localStorage.setItem('event', JSON.stringify(course));
    localStorage.setItem('eventId', JSON.stringify(course.event_id));
    localStorage.setItem('realHomeworkId', JSON.stringify(course.homework_id));
    navigate('/homework', { state: { from: location.pathname } });
  };

  const setLink = (link) => {
    window.open(link, '_blank');
  };
  const shouldPulse = course.homework_icon_color != 4;
  const hex = homeworkColors[course.homework_icon_color];
  const pulseStyle = shouldPulse ? { '--pulse-color': hex } : {};
  return (
    <tr className='table-body__row'>
      <td className='table-body__cell'>
        <CourseName img={course.image} name={course.direction_name} level={course.program_name} isViolet={true} />
      </td>
      <td className='table-body__cell table-body__cell--center'>
        <div className="program-item__btns">
          {course.presentation_link && <ButtonIcon
            classes='program-item__btn'
            icon='monitor'
            btnBg='white'
            iconColor='green'
            btnSize='lg'
            iconSize='md'
            onClick={() => setLink(course.presentation_link)}
          />}
          {course.google_pdf_url && <ButtonIcon
            classes='program-item__btn'
            icon='pdf'
            btnBg='white'
            iconColor='green'
            btnSize='lg'
            iconSize='md'
            onClick={() => setLink(course.google_pdf_url)}
          />}
          {course.youtube_link && <ButtonIcon
            classes='program-item__btn'
            icon='youtube'
            btnBg='white'
            iconColor='green'
            btnSize='lg'
            iconSize='md'
            onClick={() => setLink(course.youtube_link)}
          />}
          {course.vocabulary_link && <ButtonIcon
            classes='program-item__btn'
            icon='list'
            btnBg='white'
            iconColor='green'
            btnSize='lg'
            iconSize='md'
            onClick={() => setLink(course.vocabulary_link)}
          />}
          <VocabularyButton classes='program-item__btn' token={course.vocabulary_token} />

          {course.is_show_homework && (
            <div className="homework-icon-wrapper">
              {course.is_show_icon_new && (
                <div className="new-badge">new</div>
              )}
              <ButtonIcon
                classes={`program-item__btn ${shouldPulse ? 'pulsing-icon' : ''}`}
                icon='book'
                btnBg='white'
                iconColor={homeworkColors[course.homework_icon_color]}
                btnSize='lg'
                iconSize='md'
                onClick={() => setHomeworkPage(course)}
                style={pulseStyle}
              />
            </div>
          )}
        </div>
      </td>
      <td className='table-body__cell table-body__cell--center'
        style={course.product_status === 5 ? { pointerEvents: 'none' } : {}}
      >
        <Button
          buttonBg="green"
          loading=""
          onClick={() => getAccounts(course.product_id, 'trial_courses')}
          disabled={course.product_status === 5}
        >
          {course.product_status === 5 ? 'Оплачено' : 'Оплатити'}
        </Button>
      </td>
    </tr>
  );
};

ProgramsTableRow.propTypes = {
  course: PropTypes.object.isRequired,
  getAccounts: PropTypes.func.isRequired,
};

export default ProgramsTableRow;